module.exports = __webpack_public_path__ + "static/media/rgs_clinic_accessories.844657f6.png";